import Quill from 'quill';
import QuillSym from './QuillSym';

const SnowTheme = Quill.import('themes/snow');

function getCustomIcon(format, element) {
    const iconData = QuillSym[format];
    if (!iconData) return '';

    if (typeof iconData === 'object') {
        const key = element.getAttribute('value') || element.getAttribute('data-value') || '';
        return iconData[key] || '';
    }
    return iconData;
}

class QuillTheme extends SnowTheme {
    constructor(quill, options) {
        super(quill, options);
        quill.container.classList.replace('ql-snow', 'ql-quantum');
    }

    extendToolbar(toolbar) {
        super.extendToolbar(toolbar);
        if (!toolbar.container) return;

        toolbar.container.classList.replace('ql-snow', 'ql-quantum');

        toolbar.container.querySelectorAll('button').forEach(button => {
            const formatClass = Array.from(button.classList).find(
                cls => cls.startsWith('ql-')
            );
            if (!formatClass) return;
            const format = formatClass.replace('ql-', '');
            const icon = getCustomIcon(format, button);
            if (icon) {
                button.innerHTML = icon;
            }
        });

        toolbar.container.querySelectorAll('.ql-picker:not(.ql-icon-picker)').forEach(picker => {
            const formatClass = Array.from(picker.classList).find(
                cls => cls !== 'ql-picker' && cls.startsWith('ql-')
            );
            if (!formatClass) return;
            const format = formatClass.replace('ql-', '');
            const label = picker.querySelector('.ql-picker-label');

            if (label) {
                const labelIcon = getCustomIcon(format, '');
                if (labelIcon) {
                    label.innerHTML = labelIcon;
                }
            }
        });

        toolbar.container.querySelectorAll('.ql-icon-picker').forEach(picker => {
            const formatClass = Array.from(picker.classList).find(
                cls => cls !== 'ql-icon-picker' && cls.startsWith('ql-')
            );
            if (!formatClass) return;
            const format = formatClass.replace('ql-', '');
            const label = picker.querySelector('.ql-picker-label');

            if (label) {
                const labelIcon = getCustomIcon(format, label);
                if (labelIcon) {
                    label.innerHTML = labelIcon;
                }
            }

            const options = picker.querySelector('.ql-picker-options');
            if (options) {
                options.querySelectorAll('.ql-picker-item').forEach(item => {
                    const icon = getCustomIcon(format, item);
                    if (icon) {
                        item.innerHTML = icon;
                    }
                });
            }
        });
    }
}

QuillTheme.className = 'ql-quantum';

export default QuillTheme;
